/* nebe / výpis kolekce po barvách (v3)
   Custom element <nebe-kolekce>: vlastní lišta filtrů (rozbalovače, mobilní drawer),
   načítání výsledků přes Section Rendering API, filtr barev, dávky po 24, počet výsledků,
   návrat na dlaždici z PDP, líné fotky a swipe, „Číst dál" u popisu. Markup viz KONTRAKT.md v3.

   facets.js se na stránce nepoužívá. Server dostává jen parametry formuláře; ?barva= a ?n=
   řeší klient a drží je v URL. Pořadí stavu musí sedět se snippets/nebe-kt-early.liquid. */
(function () {
  'use strict';

  var STATE_KEY = 'nebe-kt:';
  var RETURN_KEY = 'nebe-kt-ret:';
  var RETURN_TTL = 30 * 60 * 1000;
  var CLIENT_PARAMS = ['barva', 'n', 'section_id', 'page'];
  var DESKTOP = '(min-width: 990px)';
  // barvy vybrané v rámci téhle stránky, přežijí re-render sekce zvenku
  var memo = {};

  /* ---------- čisté funkce (testované v test/logic.test.mjs) ---------- */

  function parseColors(value) {
    var out = [];
    String(value || '').toLowerCase().split(',').forEach(function (part) {
      var key = part.trim();
      if (/^[a-z0-9-]{1,40}$/.test(key) && out.indexOf(key) === -1) out.push(key);
    });
    return out;
  }

  function parseN(value, page) {
    var n = parseInt(value, 10);
    return n > page ? n : page;
  }

  // cs i sk: 1 / 2–4 / 0 a 5+
  function pluralForm(n) {
    if (n === 1) return 'one';
    if (n >= 2 && n <= 4) return 'few';
    return 'many';
  }

  function fill(tpl, map) {
    return String(tpl || '').replace(/%([a-z])/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(map, k) ? String(map[k]) : m;
    });
  }

  // items: [{ed, keep, base, top}] → {rows: [{hidden, rest}], total, shown}
  // Editoriál je „rest", když leží až za poslední ukázanou dlaždicí.
  function plan(items, colors, n) {
    var set = {};
    colors.forEach(function (c) { set[c] = true; });
    var filtered = colors.length > 0;
    var rows = [];
    var total = 0;
    var i;
    for (i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it.ed && (filtered ? set[it.base] === true : it.top)) total++;
    }
    var seen = 0;
    for (i = 0; i < items.length; i++) {
      var item = items[i];
      var visible;
      if (item.ed) visible = filtered ? (item.keep && total > 0) : true;
      else visible = filtered ? set[item.base] === true : item.top;
      var rest = false;
      if (visible) {
        rest = seen >= n;
        if (!item.ed) seen++;
      }
      rows.push({ hidden: !visible, rest: rest });
    }
    return { rows: rows, total: total, shown: Math.min(total, n) };
  }

  // URL: ostatní parametry zachovat, barvy bez %2C
  function buildSearch(search, colors, n, page) {
    var params = new URLSearchParams(search);
    params.delete('barva');
    params.delete('n');
    var parts = [];
    var rest = params.toString();
    if (rest) parts.push(rest);
    if (colors.length) parts.push('barva=' + colors.join(','));
    if (n > page) parts.push('n=' + n);
    return parts.length ? '?' + parts.join('&') : '';
  }

  // parametry pro server: bez klientských a bez prázdných hodnot (cena bez čísla)
  function serverQuery(pairs) {
    var out = new URLSearchParams();
    pairs.forEach(function (p) {
      var k = p[0];
      var v = p[1];
      if (typeof v !== 'string' || v === '' || CLIENT_PARAMS.indexOf(k) !== -1) return;
      out.append(k, v);
    });
    return out.toString();
  }

  var api = {
    parseColors: parseColors, parseN: parseN, pluralForm: pluralForm, fill: fill,
    plan: plan, buildSearch: buildSearch, serverQuery: serverQuery
  };
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (typeof window === 'undefined' || typeof HTMLElement === 'undefined') return;
  if (!window.customElements || window.customElements.get('nebe-kolekce')) return;

  /* ---------- prostředí ---------- */

  function ssGet(key) {
    try {
      var v = window.sessionStorage.getItem(key);
      return v ? JSON.parse(v) : null;
    } catch (e) { return null; }
  }
  function ssSet(key, value) {
    try { window.sessionStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* plné nebo zakázané */ }
  }
  function ssDel(key) {
    try { window.sessionStorage.removeItem(key); } catch (e) { /* nic */ }
  }
  function navType() {
    try {
      var entry = performance.getEntriesByType('navigation')[0];
      return entry ? entry.type : '';
    } catch (e) { return ''; }
  }
  function publish(name, data) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, data);
      }
    } catch (e) { /* analytika nesmí rozbít výpis */ }
  }
  function mq(query) {
    return !!(window.matchMedia && window.matchMedia(query).matches);
  }
  function reducedMotion() {
    return mq('(prefers-reduced-motion: reduce)');
  }
  function searchPairs(search) {
    var pairs = [];
    new URLSearchParams(search).forEach(function (v, k) { pairs.push([k, v]); });
    return pairs;
  }
  // dlaždice má vždy data-kt-base; editoriál a USP pruh ne. USP pruh (bez data-kt-ed)
  // zůstává i při filtru barev, editoriál jen s data-kt-keep="1".
  function metaOf(el) {
    return {
      ed: !el.hasAttribute('data-kt-base'),
      keep: el.getAttribute('data-kt-keep') === '1' || !el.hasAttribute('data-kt-ed'),
      base: el.getAttribute('data-kt-base') || '',
      top: el.getAttribute('data-kt-top') === '1'
    };
  }
  function gridItems(root) {
    var grid = root && root.querySelector('.nebe-kt-grid');
    if (!grid) return [];
    return Array.prototype.filter.call(grid.children, function (el) {
      return el.classList.contains('nebe-kt-item');
    });
  }
  function ddKey(dd) {
    return dd.getAttribute('data-kt-dd') || '';
  }

  /* ---------- element ---------- */

  class NebeKolekce extends HTMLElement {
    constructor() {
      super();
      this._onClick = this._onClick.bind(this);
      this._onChange = this._onChange.bind(this);
      this._onSubmit = this._onSubmit.bind(this);
      this._onPageShow = this._onPageShow.bind(this);
      this._onPopState = this._onPopState.bind(this);
      this._onDocClick = this._onDocClick.bind(this);
      this._onKey = this._onKey.bind(this);
      this._onResize = this._onResize.bind(this);
      this._onCountMutation = this._onCountMutation.bind(this);
    }

    connectedCallback() {
      if (this._on) return;
      this._on = true;
      try { this._init(); } catch (e) { if (window.console) console.error('nebe-kolekce', e); }
    }

    disconnectedCallback() {
      this._on = false;
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('change', this._onChange);
      this.removeEventListener('submit', this._onSubmit);
      window.removeEventListener('pageshow', this._onPageShow);
      window.removeEventListener('popstate', this._onPopState);
      window.removeEventListener('resize', this._onResize);
      document.removeEventListener('click', this._onDocClick);
      document.removeEventListener('keydown', this._onKey);
      if (this._countObserver) this._countObserver.disconnect();
      if (this._ro) this._ro.disconnect();
      if (this._gridRO) this._gridRO.disconnect();
      if (this._abort) this._abort.abort();
      if (this._drawerOpen) this._closeDrawer(false);
      this._countObserver = this._ro = this._abort = null;
    }

    _init() {
      this.page = parseInt(this.dataset.page, 10) || 24;
      this.path = window.location.pathname;
      this.form = this.querySelector('[data-kt-form]');
      this.bar = this.querySelector('[data-kt-bar]');
      this.drawer = this.querySelector('[data-kt-drawer]');
      this.results = this.querySelector('[data-kt-results]') || this;
      this._defaultSort = this._readDefaultSort();
      this._qs = this._clean(serverQuery(searchPairs(window.location.search)));

      this.addEventListener('click', this._onClick);
      this.addEventListener('change', this._onChange);
      this.addEventListener('submit', this._onSubmit);
      window.addEventListener('pageshow', this._onPageShow);
      window.addEventListener('popstate', this._onPopState);
      window.addEventListener('resize', this._onResize);
      document.addEventListener('click', this._onDocClick);
      document.addEventListener('keydown', this._onKey);

      var back = navType() === 'back_forward';
      if (back && 'scrollRestoration' in history) {
        // pozici řešíme sami podle kliknuté dlaždice
        try { history.scrollRestoration = 'manual'; } catch (e) { /* nic */ }
      }

      this._readServerN();
      this._bindGrid();
      this.apply(this._readState(), true);
      this._watchCount();
      this._setupClamp();
      this._measureSticky();
      var self = this;
      // Jost se dotahuje později a mění výšku zalomených řádků
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (self._on) self._scheduleAlign(); });
      if (back) this._restoreReturn();
    }

    /* ---------- stav barev a dávek ---------- */

    // URL > paměť stránky > sessionStorage (jen zpět / reload)
    _readState() {
      var params = new URLSearchParams(window.location.search);
      if (params.has('barva') || params.has('n')) {
        return { colors: parseColors(params.get('barva')), n: parseN(params.get('n'), this.page) };
      }
      if (memo[this.path]) return { colors: memo[this.path].colors.slice(), n: this.page };
      var type = navType();
      if (type === 'back_forward' || type === 'reload') {
        var saved = ssGet(STATE_KEY + this.path);
        if (saved) return { colors: parseColors((saved.c || []).join(',')), n: parseN(saved.n, this.page) };
      }
      return { colors: [], n: this.page };
    }

    _bindGrid() {
      this.grid = this.results.querySelector('.nebe-kt-grid');
      this.items = gridItems(this.results);
      this.meta = this.items.map(metaOf);
      this._moved = false;
      this._arrCols = 0;
      // původní pořadí editoriálu; rozmístění se vždy počítá od něj
      this.items.forEach(function (el, i) {
        if (el.classList.contains('nebe-kt-item--ed') && !el.classList.contains('nebe-kt-item--usp')) el.setAttribute('data-kt-home-index', i);
      });
      this._watchGrid();
    }

    // šířka mřížky (okno, drawer motivu, rotace): rozmístit editoriály a srovnat výšky.
    // Jen při změně šířky, výška se na mobilu mění při každém scrollu (lišta prohlížeče).
    _watchGrid() {
      if (!window.ResizeObserver) return;
      var self = this;
      if (!this._gridRO) {
        this._gridRO = new ResizeObserver(function (entries) {
          var w = Math.round(entries[entries.length - 1].contentRect.width);
          if (w === self._gridW) return;
          var first = self._gridW === undefined;
          self._gridW = w;
          if (first || !self._on) return;
          if (self._gridT) clearTimeout(self._gridT);
          self._gridT = setTimeout(function () {
            if (!self._on) return;
            self._arrange(true);
            self._scheduleAlign();
          }, 100);
        });
      }
      this._gridRO.disconnect();
      this._gridW = undefined;
      if (this.grid) this._gridRO.observe(this.grid);
    }

    apply(state, writeUrl) {
      var res = plan(this.meta, state.colors, state.n);
      var i;
      for (i = 0; i < this.items.length; i++) {
        var el = this.items[i];
        var row = res.rows[i];
        if (el.hidden !== row.hidden) el.hidden = row.hidden;
        if (el.classList.contains('is-kt-rest') !== row.rest) el.classList.toggle('is-kt-rest', row.rest);
      }
      this.state = { colors: state.colors.slice(), n: state.n };
      this.total = res.total;
      this.shown = res.shown;

      this._paintChips(state.colors);
      this._paintActive();

      // prázdný stav patří jen filtru barev; .nebe-kt-empty--server kreslí sekce a JS na něj nesahá
      var none = res.total === 0 && state.colors.length > 0;
      var empty = this.results.querySelector('.nebe-kt-empty:not(.nebe-kt-empty--server)');
      if (empty) empty.hidden = !none;
      if (this.grid && this.grid.hidden !== none) this.grid.hidden = none;

      var more = this.results.querySelector('.nebe-kt-more');
      if (more) {
        more.hidden = res.shown >= res.total;
        var info = more.querySelector('.nebe-kt-more__info');
        if (info) info.textContent = fill(info.getAttribute('data-tpl'), { a: res.shown, b: res.total });
      }

      this.countText = this._countFor(res.total);
      this._writeCount();

      this._arrange(false);
      this._scheduleAlign();

      this.setAttribute('data-kt-state', state.colors.join(',') + '|' + state.n);
      memo[this.path] = { colors: state.colors.slice() };
      ssSet(STATE_KEY + this.path, { c: state.colors, n: state.n });
      if (writeUrl) this._writeUrl();
    }

    _countFor(n) {
      var tpl = this.getAttribute('data-count-' + pluralForm(n));
      return tpl ? fill(tpl, { n: n }) : null;
    }

    _paintChips(colors) {
      var chips = this.querySelectorAll('.nebe-kt-cf__chip');
      for (var i = 0; i < chips.length; i++) {
        var on = colors.indexOf(chips[i].getAttribute('data-kt-base')) !== -1 ? 'true' : 'false';
        if (chips[i].getAttribute('aria-pressed') !== on) chips[i].setAttribute('aria-pressed', on);
      }
      var clear = this.querySelector('.nebe-kt-cf__clear');
      if (clear) clear.hidden = colors.length === 0;
      var n = this.querySelector('.nebe-kt-dd[data-kt-dd="barva"] .nebe-kt-dd__n');
      if (n) n.textContent = colors.length ? '(' + colors.length + ')' : '';
    }

    _chipLabel(base) {
      var chip = this.querySelector('.nebe-kt-cf__chip[data-kt-base="' + base + '"]');
      var label = chip && (chip.querySelector('.nebe-kt-cf__label') || chip);
      return label ? label.textContent.replace(/\s*\d+\s*$/, '').trim() : base;
    }

    // štítky vybraných barev přidává JS vedle štítků ze serveru
    _paintActive() {
      var box = this.querySelector('.nebe-kt-active');
      if (!box) return;
      var old = box.querySelectorAll('[data-kt-js]');
      for (var i = 0; i < old.length; i++) old[i].remove();
      var colors = this.state.colors;
      var clear = box.querySelector('.nebe-kt-active__clear');
      var self = this;
      colors.forEach(function (base) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'nebe-kt-active__i';
        b.setAttribute('data-kt-js', '');
        b.setAttribute('data-kt-base', base);
        b.textContent = self._chipLabel(base) + ' ';
        var x = document.createElement('span');
        x.setAttribute('aria-hidden', 'true');
        x.textContent = '×';
        b.appendChild(x);
        box.insertBefore(b, clear);
      });
      box.hidden = !colors.length && !box.querySelector('.nebe-kt-active__i');
      this._paintOpenN();
      if (colors.length && !clear) {
        var c = document.createElement('button');
        c.type = 'button';
        c.className = 'nebe-kt-active__clear';
        c.setAttribute('data-kt-js', '');
        var src = this.querySelector('.nebe-kt-cf__clear, .nebe-kt-drawer__clear');
        c.textContent = src ? src.textContent.trim() : '×';
        box.appendChild(c);
      }
    }

    // počet aktivních filtrů na tlačítku Filtrovat: server + vybrané barvy
    _readServerN() {
      var el = this.querySelector('.nebe-kt-bar__n:not([data-kt-js])');
      this._srvN = el ? parseInt(el.textContent.replace(/\D+/g, ''), 10) || 0 : 0;
    }
    _paintOpenN() {
      var btn = this.querySelector('.nebe-kt-bar__open');
      if (!btn) return;
      var n = (this._srvN || 0) + this.state.colors.length;
      var el = btn.querySelector('.nebe-kt-bar__n');
      if (!n) { if (el) el.remove(); return; }
      if (!el) {
        el = document.createElement('span');
        el.className = 'nebe-kt-bar__n';
        el.setAttribute('data-kt-js', '');
        btn.appendChild(el);
      }
      el.textContent = '(' + n + ')';
      el.setAttribute('data-kt-js', '');   // _readServerN už ho nesmí brát jako číslo ze serveru
    }

    _writeUrl() {
      try {
        var loc = window.location;
        var search = buildSearch(loc.search, this.state.colors, this.state.n, this.page);
        if (search !== loc.search) history.replaceState(history.state, '', loc.pathname + search + loc.hash);
      } catch (e) { /* nic */ }
    }

    _countEls() {
      var out = [];
      ['ProductCount', 'ProductCountMobile', 'ProductCountDesktop'].forEach(function (id) {
        var el = document.getElementById(id);
        if (el && out.indexOf(el) === -1) out.push(el);
      });
      var own = this.querySelectorAll('.nebe-kt-bar__count');
      for (var i = 0; i < own.length; i++) if (out.indexOf(own[i]) === -1) out.push(own[i]);
      return out;
    }

    _writeCount() {
      if (this.countText === null || this.countText === undefined) return;
      var text = this.countText;
      this._countEls().forEach(function (el) {
        if (el.textContent.trim() !== text) el.textContent = text;
      });
    }

    // cizí skript (nebo starý facets.js) může počet přepsat ze serveru: hlídat a vrátit
    _watchCount() {
      var els = this._countEls();
      if (!els.length || !window.MutationObserver) return;
      this._countObserver = new MutationObserver(this._onCountMutation);
      var obs = this._countObserver;
      els.forEach(function (el) { obs.observe(el, { childList: true, characterData: true, subtree: true }); });
    }
    _onCountMutation() {
      // _writeCount píše jen při rozdílu, takže vlastní zápis smyčku nezaloží
      if (this._on) this._writeCount();
    }

    _onPageShow(e) {
      if (!e.persisted) return;
      // bfcache: DOM i scroll jsou zpět, jen srovnat URL a počet
      this._writeUrl();
      this._writeCount();
      ssDel(RETURN_KEY + this.path);
    }

    /* ---------- načítání výsledků (Section Rendering API) ---------- */

    _formQuery() {
      if (!this.form) return '';
      var pairs = [];
      new FormData(this.form).forEach(function (v, k) { pairs.push([k, v]); });
      return this._clean(serverQuery(pairs));
    }

    // výchozí řazení kolekce do URL nepatří (jinak by každá změna nesla sort_by=manual)
    _readDefaultSort() {
      if (this.dataset.defaultSort) return this.dataset.defaultSort;
      if (new URLSearchParams(window.location.search).has('sort_by')) return '';
      var r = this.querySelector('input[name="sort_by"]:checked');
      return r ? r.value : '';
    }
    _clean(qs) {
      if (!this._defaultSort) return qs;
      var p = new URLSearchParams(qs);
      if (p.get('sort_by') === this._defaultSort) p.delete('sort_by');
      return p.toString();
    }

    _fetch(qs) {
      if (this._abort) this._abort.abort();
      var ctrl = window.AbortController ? new AbortController() : null;
      this._abort = ctrl;
      var url = this.path + '?' + (qs ? qs + '&' : '') + 'section_id=' + encodeURIComponent(this.dataset.section || '');
      return fetch(url, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
    }

    // opts: {push, colors, n}
    _load(qs, opts) {
      opts = opts || {};
      var self = this;
      this.results.classList.add('is-kt-loading');
      this.results.setAttribute('aria-busy', 'true');
      return this._fetch(qs).then(function (doc) {
        self._applyDoc(doc, qs, opts);
      }).catch(function (e) {
        if (e && e.name === 'AbortError') return;
        // bez JS cesty: plná navigace se stejnými parametry
        window.location.href = self.path + (qs ? '?' + qs : '');
      }).then(function () {
        self.results.classList.remove('is-kt-loading');
        self.results.removeAttribute('aria-busy');
      });
    }

    _applyDoc(doc, qs, opts) {
      this._swap(doc);
      this._qs = qs;
      this._preview = null;
      if (opts.push) {
        try { history.pushState({ nebeKt: qs }, '', this.path + (qs ? '?' + qs : '')); } catch (e) { /* nic */ }
      }
      this.apply({ colors: opts.colors || this.state.colors, n: opts.n || this.page }, true);
      if (opts.push) {
        publish('nebe:filter', { query: qs, results: this.total });
        this._scrollToResults(opts.scroll === 'force');
      }
    }

    // z odpovědi vyměnit výsledky, počet, aktivní štítky a panely rozbalovačů
    _swap(doc) {
      var focusKey = this._focusKey();
      var nr = doc.querySelector('[data-kt-results]');
      if (nr && this.results !== this) this.results.innerHTML = nr.innerHTML;

      var nc = doc.querySelector('.nebe-kt-bar__count');
      var cc = this.querySelector('.nebe-kt-bar__count');
      if (nc && cc) cc.textContent = nc.textContent;

      var na = doc.querySelector('.nebe-kt-active');
      var ca = this.querySelector('.nebe-kt-active');
      if (na && ca) {
        ca.innerHTML = na.innerHTML;
        ca.hidden = na.hidden;
      }

      // zkratky typu nesou stav --on a odkazy add/remove podle aktuálních filtrů
      var nt = doc.querySelector('.nebe-kt-cats');
      var ct = this.querySelector('.nebe-kt-cats');
      if (nt && ct && ct.querySelector('[data-kt-typ]')) {
        var sl = ct.scrollLeft;
        ct.innerHTML = nt.innerHTML;
        ct.scrollLeft = sl;
      }

      var no = doc.querySelector('.nebe-kt-bar__open');
      var co = this.querySelector('.nebe-kt-bar__open');
      if (no && co) co.innerHTML = no.innerHTML;
      this._readServerN();

      var fresh = {};
      Array.prototype.forEach.call(doc.querySelectorAll('[data-kt-dd]'), function (dd) { fresh[ddKey(dd)] = dd; });
      Array.prototype.forEach.call(this.querySelectorAll('[data-kt-dd]'), function (dd) {
        var src = fresh[ddKey(dd)];
        if (!src) return;
        // přepínač (Skladem) je jen label s inputem
        if (!dd.classList.contains('nebe-kt-dd')) { dd.innerHTML = src.innerHTML; return; }
        var p = dd.querySelector('.nebe-kt-dd__panel');
        var sp = src.querySelector('.nebe-kt-dd__panel');
        if (p && sp) p.innerHTML = sp.innerHTML;
        if (ddKey(dd) === 'barva') return;   // počet barev píše JS
        var b = dd.querySelector('.nebe-kt-dd__btn');
        var sb = src.querySelector('.nebe-kt-dd__btn');
        if (b && sb) b.innerHTML = sb.innerHTML;
      });

      this._bindGrid();
      this._restoreFocus(focusKey);
    }

    _focusKey() {
      var a = document.activeElement;
      if (!a || !this.contains(a)) return null;
      if (a.name) return { name: a.name, value: a.value, type: a.type };
      if (a.hasAttribute('data-kt-base')) return { base: a.getAttribute('data-kt-base') };
      return null;
    }
    _restoreFocus(key) {
      if (!key) return;
      var el = null;
      var list = this.querySelectorAll(key.base ? '.nebe-kt-cf__chip' : 'input, select');
      for (var i = 0; i < list.length && !el; i++) {
        var c = list[i];
        if (key.base ? c.getAttribute('data-kt-base') === key.base
          : c.name === key.name && (key.type === 'number' || c.value === key.value)) el = c;
      }
      if (el) el.focus({ preventScroll: true });
    }

    // Posun na výsledky: lišta filtrů hned pod hlavičkou. force = i když jsou výsledky pod
    // záhybem (kolečka typů); jinak jen když uživatel odscrolloval pod začátek výsledků.
    // Počítá s viditelnou hlavičkou: když se motiv při scrollu dolů schová, zůstane nad lištou
    // kousek úvodu, nic se ale nepřekryje.
    _scrollToResults(force) {
      var top = this.results.getBoundingClientRect().top;
      var sticky = this.bar && this.bar.hasAttribute('data-kt-sticky');
      var head = this._headerOffset();
      var offset = head + (this.bar ? this.bar.offsetHeight : 0);
      if (!sticky && this.bar) {
        // lišta se nelepí: srovnat na její horní hranu
        top = this.bar.getBoundingClientRect().top;
        offset = head;
      }
      if (!force && top >= offset) return;
      if (Math.abs(top - offset) < 2) return;
      window.scrollTo({ top: Math.max(0, window.pageYOffset + top - offset), behavior: reducedMotion() ? 'auto' : 'smooth' });
    }

    // výška hlavičky motivu, pod kterou se lišta lepí (přilepená hlavička Be Yours = sticky-header)
    _headerOffset() {
      var v = parseInt(getComputedStyle(this).getPropertyValue('--kt-sticky-top'), 10) || 0;
      if (document.querySelector('sticky-header')) {
        var sec = document.querySelector('.shopify-section-header, #shopify-section-header');
        if (sec && sec.offsetHeight > v) v = sec.offsetHeight;
      }
      return v;
    }

    _onPopState() {
      if (window.location.pathname !== this.path) return;
      var params = new URLSearchParams(window.location.search);
      var colors = parseColors(params.get('barva'));
      var n = parseN(params.get('n'), this.page);
      var qs = this._clean(serverQuery(searchPairs(window.location.search)));
      if (this._drawerOpen) this._closeDrawer(false);
      this._closeDds();
      if (qs === this._qs) this.apply({ colors: colors, n: n }, false);
      else this._load(qs, { push: false, colors: colors, n: n });
    }

    /* ---------- formulář, rozbalovače, drawer ---------- */

    _onChange(e) {
      var t = e.target;
      if (!this.form || !(t instanceof Element) || !t.name || !this.form.contains(t)) return;
      if (this._drawerOpen) { this._schedulePreview(); return; }
      var qs = this._formQuery();
      if (qs !== this._qs) this._load(qs, { push: true, colors: this.state.colors });
    }

    _onSubmit(e) {
      if (e.target !== this.form) return;
      e.preventDefault();
      if (this._drawerOpen) { this._drawerApply(); return; }
      var qs = this._formQuery();
      if (qs !== this._qs) this._load(qs, { push: true, colors: this.state.colors });
    }

    _toggleDd(dd, force) {
      var btn = dd.querySelector('.nebe-kt-dd__btn');
      var panel = dd.querySelector('.nebe-kt-dd__panel');
      if (!btn || !panel) return;
      var open = typeof force === 'boolean' ? force : btn.getAttribute('aria-expanded') !== 'true';
      // v liště je otevřený nejvýš jeden, v draweru jde o akordeon
      if (open && !this._drawerOpen) this._closeDds(dd);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
    }

    _closeDds(except) {
      var dds = this.querySelectorAll('.nebe-kt-dd');
      for (var i = 0; i < dds.length; i++) {
        if (dds[i] === except) continue;
        var btn = dds[i].querySelector('.nebe-kt-dd__btn');
        if (btn && btn.getAttribute('aria-expanded') === 'true') this._toggleDd(dds[i], false);
      }
    }

    _openDd() {
      return this.querySelector('.nebe-kt-dd__btn[aria-expanded="true"]');
    }

    _onDocClick(e) {
      if (this._drawerOpen) return;
      var btn = this._openDd();
      if (!btn) return;
      var dd = btn.closest('.nebe-kt-dd');
      if (dd && !dd.contains(e.target)) this._toggleDd(dd, false);
    }

    _onKey(e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      if (this._drawerOpen) { this._closeDrawer(false); return; }
      var btn = this._openDd();
      if (!btn) return;
      this._toggleDd(btn.closest('.nebe-kt-dd'), false);
      btn.focus();
    }

    _onResize() {
      var self = this;
      if (this._rzRaf) return;
      this._rzRaf = window.requestAnimationFrame(function () {
        self._rzRaf = 0;
        if (self._drawerOpen && mq(DESKTOP)) self._closeDrawer(false);
        self._measureSticky();
        self._checkClamp();
      });
    }

    /* ---------- rozmístění editoriálů podle počtu sloupců ---------- */

    // Editoriály nesmí stát pod sebou: mezi dvěma aspoň jedna celá řada produktů, nikdy ve
    // stejném sloupci, ideálně střídají strany (jako Tala). Počítá se nad skutečným počtem
    // sloupců mřížky; když pravidlo neplatí, editoriál se v DOM posune o nejmenší počet dlaždic.
    // Vždy od původního pořadí (this.items), data-kt-index dlaždic se nemění.
    _arrange(onlyIfColsChanged) {
      if (!this.grid) return;
      var tpl = getComputedStyle(this.grid).gridTemplateColumns;
      var cols = tpl && tpl !== 'none' ? tpl.trim().split(/\s+/).length : 1;
      if (onlyIfColsChanged && cols === this._arrCols) return;
      this._arrCols = cols;
      var grid = this.grid;
      if (this._moved) {
        this.items.forEach(function (el) { grid.appendChild(el); });
        this._moved = false;
      }
      this.items.forEach(function (el) { if (el.classList.contains('is-kt-ed-off')) el.classList.remove('is-kt-ed-off'); });
      if (cols < 2) return;

      var seq = [];
      for (var i = 0; i < this.items.length; i++) {
        var el = this.items[i];
        if (el.hidden || el.classList.contains('is-kt-rest') || getComputedStyle(el).display === 'none') continue;
        var usp = el.classList.contains('nebe-kt-item--usp');
        seq.push({ el: el, full: usp, ed: this.meta[i].ed && !usp });
      }
      var place = function (list) {
        var row = 0;
        var col = 0;
        return list.map(function (it) {
          var pos;
          if (it.full) {
            if (col > 0) { row++; col = 0; }
            pos = { row: row, col: 0 };
            row++;
            return pos;
          }
          pos = { row: row, col: col };
          if (++col === cols) { col = 0; row++; }
          return pos;
        });
      };

      var valid = function (list, idx, prevIt) {
        if (!prevIt) return true;
        var pos = place(list);
        var p = pos[list.indexOf(prevIt)];
        var q = pos[idx];
        return q.row - p.row >= 2 && q.col !== p.col;
      };
      var slots = seq.map(function (x) { return x.el; });
      var eds = seq.filter(function (x) { return x.ed; });
      var shownPrev = null;
      var deferred = [];
      var changed = false;
      eds.forEach(function (it, n) {
        if (n === 0) { shownPrev = it; return; }
        var k = seq.indexOf(it);
        var pIdx = seq.indexOf(shownPrev);
        var p = place(seq)[pIdx];
        var want = p.col === cols - 1 ? 0 : (p.col === 0 ? cols - 1 : -1);
        var nextEd = null;
        for (var m = n + 1; m < eds.length; m++) { if (seq.indexOf(eds[m]) > k) { nextEd = eds[m]; break; } }
        var best = null;
        for (var j = Math.max(pIdx + 1, k - cols); j <= Math.min(seq.length - 1, k + 2 * cols); j++) {
          var trial = seq.slice();
          trial.splice(j, 0, trial.splice(k, 1)[0]);
          if (nextEd && trial.indexOf(nextEd) < j) continue;   // nepřeskočit další editoriál
          if (!valid(trial, j, shownPrev)) continue;
          var q = place(trial)[j];
          var cost = Math.abs(j - k) + (want === -1 || q.col === want ? 0 : cols);
          if (!best || cost < best.cost) best = { j: j, cost: cost };
        }
        if (best) {
          if (best.j !== k) {
            seq.splice(best.j, 0, seq.splice(k, 1)[0]);
            changed = true;
          }
          shownPrev = it;
          return;
        }
        // záloha pro krátké kolekce: zkusit úplný konec mřížky, až budou rozmístěné ostatní
        seq.splice(k, 1);
        deferred.push(it);
        changed = true;
      });
      var off = [];
      deferred.forEach(function (it) {
        seq.push(it);
        if (valid(seq, seq.length - 1, shownPrev)) { shownPrev = it; return; }
        // ani na konci pravidla neplatí: editoriál se tentokrát nezobrazí
        seq.pop();
        it.el.classList.add('is-kt-ed-off');
        off.push(it.el);
      });
      if (!changed) return;
      // DOM: na místa původně viditelných položek nové pořadí (skryté editoriály nakonec),
      // ostatní skryté položky zůstanou, kde jsou
      var order = seq.map(function (x) { return x.el; }).concat(off);
      var vi = 0;
      this.items.map(function (el) { return slots.indexOf(el) !== -1 ? order[vi++] : el; })
        .forEach(function (el) { grid.appendChild(el); });
      this._moved = true;
    }

    /* ---------- zarovnání těla dlaždic v řadě: assets/nebe-dlazdice.js ---------- */

    // po změně viditelnosti (filtr, dávka, výměna, rozmístění) srovnat řady mřížky
    _scheduleAlign() {
      var grid = this.grid;
      if (!grid) return;
      if (window.NebeDlazdice) { window.NebeDlazdice.schedule(grid); return; }
      if (window.customElements && window.customElements.whenDefined) {
        window.customElements.whenDefined('nebe-dlazdice').then(function () {
          if (window.NebeDlazdice) window.NebeDlazdice.schedule(grid);
        });
      }
    }

    _openDrawer() {
      if (!this.drawer || !this.form || this._drawerOpen) return;
      this._closeDds();
      this._drawerOpen = true;
      this._pend = { colors: this.state.colors.slice() };
      this._home = document.createComment('nebe-kt-form');
      this.form.parentNode.insertBefore(this._home, this.form);
      var body = this.drawer.querySelector('[data-kt-drawer-body]');
      if (body) body.appendChild(this.form);
      else this.drawer.insertBefore(this.form, this.drawer.querySelector('.nebe-kt-drawer__foot'));
      this.drawer.hidden = false;
      document.documentElement.classList.add('nebe-kt-lock');
      this._paintApply(this.total);
      var close = this.drawer.querySelector('.nebe-kt-drawer__close');
      if (close) close.focus();
    }

    // apply=false: změny v draweru se zahodí
    _closeDrawer(apply) {
      if (!this._drawerOpen) return;
      this._drawerOpen = false;
      if (!apply && this.form) {
        this.form.reset();                  // výchozí stav = to, co naposledy vykreslil server
        this._paintChips(this.state.colors);
      }
      this._pend = null;
      this._preview = null;
      if (this._pvTimer) clearTimeout(this._pvTimer);
      // zavřít akordeony, v liště jsou z nich zase rozbalovače
      var dds = this.querySelectorAll('.nebe-kt-dd');
      for (var i = 0; i < dds.length; i++) this._toggleDd(dds[i], false);
      if (this._home && this._home.parentNode) {
        this._home.parentNode.insertBefore(this.form, this._home);
        this._home.remove();
      }
      this._home = null;
      this.drawer.hidden = true;
      document.documentElement.classList.remove('nebe-kt-lock');
      var open = this.querySelector('.nebe-kt-bar__open');
      if (open) open.focus({ preventScroll: true });
    }

    _drawerClear() {
      if (!this.form) return;
      var inputs = this.form.querySelectorAll('input');
      for (var i = 0; i < inputs.length; i++) {
        var inp = inputs[i];
        if (inp.name === 'sort_by') continue;
        if (inp.type === 'checkbox' || inp.type === 'radio') inp.checked = false;
        else if (inp.type !== 'hidden' && inp.type !== 'submit' && inp.type !== 'button') inp.value = '';
      }
      this._pend.colors = [];
      this._paintChips([]);
      this._schedulePreview();
    }

    _drawerApply() {
      var qs = this._formQuery();
      var colors = this._pend ? this._pend.colors.slice() : this.state.colors;
      var preview = this._preview;
      this._closeDrawer(true);
      if (qs === this._qs) {
        if (colors.join(',') !== this.state.colors.join(',')) {
          this.apply({ colors: colors, n: this.page }, true);
          publish('nebe:color_filter', { colors: colors, base: '', action: 'drawer', results: this.total });
        }
        return;
      }
      if (preview && preview.qs === qs && preview.doc) this._applyDoc(preview.doc, qs, { push: true, colors: colors });
      else this._load(qs, { push: true, colors: colors });
    }

    // mobil: po změně v draweru dotáhnout výsledek dopředu, ať „Zobrazit (N)" sedí
    _schedulePreview() {
      var self = this;
      if (this._pvTimer) clearTimeout(this._pvTimer);
      this._pvTimer = setTimeout(function () {
        if (!self._drawerOpen) return;
        var qs = self._formQuery();
        if (qs === self._qs) { self._preview = null; self._paintApply(self._pendingTotal()); return; }
        self._fetch(qs).then(function (doc) {
          if (!self._drawerOpen || self._formQuery() !== qs) return;
          self._preview = { qs: qs, doc: doc, meta: gridItems(doc).map(metaOf) };
          self._paintApply(self._pendingTotal());
        }).catch(function () { /* „Zobrazit" pak načte samo */ });
      }, 250);
    }

    _pendingTotal() {
      if (!this._pend) return this.total;
      var qs = this._formQuery();
      var meta = qs === this._qs ? this.meta : (this._preview && this._preview.qs === qs ? this._preview.meta : null);
      if (!meta) return null;
      return plan(meta, this._pend.colors, Infinity).total;
    }

    _paintApply(n) {
      var btn = this.drawer && this.drawer.querySelector('.nebe-kt-drawer__apply');
      if (!btn) return;
      if (!btn.hasAttribute('data-kt-label')) btn.setAttribute('data-kt-label', btn.textContent.replace(/\s*\(\d+\)\s*$/, '').trim());
      var label = btn.getAttribute('data-kt-label');
      var tpl = btn.getAttribute('data-tpl');
      if (n === null || n === undefined) btn.textContent = label;
      else btn.textContent = tpl ? fill(tpl, { n: n }) : label + ' (' + n + ')';
    }

    /* ---------- kliky ---------- */

    _onClick(e) {
      var t = e.target;
      if (!(t instanceof Element)) return;

      var ddBtn = t.closest('.nebe-kt-dd__btn');
      if (ddBtn) { this._toggleDd(ddBtn.closest('.nebe-kt-dd')); return; }
      if (t.closest('.nebe-kt-bar__open')) { this._openDrawer(); return; }
      if (t.closest('.nebe-kt-drawer__close')) { this._closeDrawer(false); return; }
      if (t.closest('.nebe-kt-drawer__apply')) { e.preventDefault(); this._drawerApply(); return; }
      if (t.closest('.nebe-kt-drawer__clear')) { e.preventDefault(); this._drawerClear(); return; }
      if (t.closest('.nebe-kt-intro__more')) { this._openClamp(); return; }

      var chip = t.closest('.nebe-kt-cf__chip');
      if (chip) { this._toggleColor(chip); return; }
      if (t.closest('.nebe-kt-cf__clear')) { this._setColors([], 'clear'); return; }
      if (t.closest('.nebe-kt-empty__reset')) { this._setColors([], 'clear', true); return; }

      var act = t.closest('.nebe-kt-active__i, .nebe-kt-active__clear');
      if (act) { this._onActive(e, act); return; }
      // zkratky typu (hodnoty filtru) načíst bez přechodu stránky; zkratky do jiných kolekcí jsou běžné odkazy
      var typ = t.closest('a.nebe-kt-cats__i[data-kt-typ]');
      if (typ && !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button === 0) {
        e.preventDefault();
        this._pickTyp(typ);
        return;
      }

      if (t.closest('.nebe-kt-more__btn')) { this._more(); return; }

      var li = t.closest('.nebe-kt-item');
      if (!li || !this.grid || !this.grid.contains(li)) return;
      var index = parseInt(li.getAttribute('data-kt-index'), 10);
      var link = t.closest('a');

      if (li.classList.contains('nebe-kt-item--ed')) {
        if (!link) return;
        this._saveReturn(li);
        publish('nebe:select_promotion', { index: index, type: li.getAttribute('data-kt-ed') || '', url: link.href });
        return;
      }

      // dlaždice si klik (analytika, fotka → detail, tažení) řeší sama; výpis si jen pamatuje pozici
      if (link || t.closest('.nebe-kt-card__media')) this._saveReturn(li);
    }

    _onActive(e, el) {
      e.preventDefault();
      var isClear = el.classList.contains('nebe-kt-active__clear');
      var base = el.getAttribute('data-kt-base');
      if (base) {
        this._setColors(this.state.colors.filter(function (c) { return c !== base; }), 'remove');
        return;
      }
      var colors = isClear ? [] : this.state.colors;
      var href = el.getAttribute('href');
      if (!href) {
        // štítek bez odkazu (zrušit vše od JS): pryč se vším kromě řazení
        var keep = new URLSearchParams(this._qs).get('sort_by');
        var qs0 = keep ? 'sort_by=' + encodeURIComponent(keep) : '';
        if (qs0 === this._qs) this.apply({ colors: colors, n: this.page }, true);
        else this._load(qs0, { push: true, colors: colors });
        return;
      }
      this._loadHref(href, colors);
    }

    // Kolečka typů jsou kategorie: vybraná je nejvýš jedna. Klik na nevybrané nahradí všechny
    // hodnoty filtru typu jen touto, klik na vybrané typ zruší. Ostatní filtry, barva a řazení
    // zůstanou. Rozbalovač typu v liště zůstává vícenásobný. href (url_to_add/remove) platí bez JS.
    _pickTyp(a) {
      var param = this._typParam();
      var value = a.getAttribute('data-kt-typ');
      if (!param || value === null) { this._loadHref(a.getAttribute('href'), this.state.colors); return; }
      var on = a.classList.contains('nebe-kt-cats__i--on');
      var pairs = searchPairs(this._qs).filter(function (p) { return p[0] !== param; });
      if (!on) pairs.push([param, value]);
      var qs = this._clean(serverQuery(pairs));
      publish('nebe:category', { value: value, action: on ? 'remove' : 'set' });
      if (qs === this._qs) { this._scrollToResults(true); return; }
      this._load(qs, { push: true, colors: this.state.colors, scroll: 'force' });
    }

    // název parametru typu: z odkazů koleček (url_to_add nese hodnotu data-kt-typ), záloha metapole
    _typParam() {
      if (this._typKey) return this._typKey;
      var nav = this.querySelector('.nebe-kt-cats');
      if (nav && nav.getAttribute('data-kt-param')) return (this._typKey = nav.getAttribute('data-kt-param'));
      var links = this.querySelectorAll('a.nebe-kt-cats__i[data-kt-typ]');
      for (var i = 0; i < links.length; i++) {
        var v = links[i].getAttribute('data-kt-typ');
        var found = null;
        new URL(links[i].getAttribute('href'), window.location.href).searchParams.forEach(function (val, key) {
          if (!found && val === v && key.indexOf('filter.') === 0) found = key;
        });
        if (found) return (this._typKey = found);
      }
      return 'filter.p.m.custom.typ_produktu';
    }

    _loadHref(href, colors) {
      var url = new URL(href, window.location.href);
      var qs = this._clean(serverQuery(searchPairs(url.search)));
      if (qs === this._qs) this.apply({ colors: colors, n: this.page }, true);
      else this._load(qs, { push: true, colors: colors });
    }

    _toggleColor(chip) {
      var base = chip.getAttribute('data-kt-base');
      if (!base) return;
      var src = this._drawerOpen && this._pend ? this._pend.colors : this.state.colors;
      var colors = src.slice();
      var at = colors.indexOf(base);
      if (at === -1) colors.push(base); else colors.splice(at, 1);
      if (this._drawerOpen && this._pend) {
        this._pend.colors = colors;
        this._paintChips(colors);
        this._paintApply(this._pendingTotal());
        return;
      }
      this._setColors(colors, at === -1 ? 'add' : 'remove', false, base);
    }

    _setColors(colors, action, focusFirst, base) {
      if (this._drawerOpen && this._pend) {
        this._pend.colors = colors.slice();
        this._paintChips(colors);
        this._paintApply(this._pendingTotal());
        return;
      }
      this.apply({ colors: colors, n: this.page }, true);
      publish('nebe:color_filter', { colors: colors, base: base || '', action: action, results: this.total });
      if (focusFirst) {
        var first = this.grid && this.grid.querySelector('.nebe-kt-item:not([hidden]) a');
        if (first) first.focus({ preventScroll: true });
      }
    }

    _more() {
      var before = this.shown;
      this.apply({ colors: this.state.colors, n: before + this.page }, true);
      // fokus na první nově ukázanou dlaždici, ať klávesnice nezačíná znovu nahoře
      var seen = 0;
      for (var i = 0; i < this.items.length; i++) {
        var el = this.items[i];
        if (el.hidden || this.meta[i].ed) continue;
        if (seen === before) {
          var link = el.querySelector('.nebe-kt-card__link');
          if (link) link.focus({ preventScroll: true });
          break;
        }
        seen++;
      }
    }

    /* ---------- návrat z PDP ---------- */

    _saveReturn(li) {
      ssSet(RETURN_KEY + this.path, { i: li.getAttribute('data-kt-index'), n: this.shown, t: Date.now() });
    }

    _restoreReturn() {
      var ret = ssGet(RETURN_KEY + this.path);
      ssDel(RETURN_KEY + this.path);
      if (!this.grid || !ret || ret.i === null || ret.i === undefined || Date.now() - (ret.t || 0) > RETURN_TTL) return;
      var li = this.grid.querySelector('.nebe-kt-item[data-kt-index="' + String(ret.i).replace(/[^0-9]/g, '') + '"]');
      if (!li || li.hidden) return;
      if (li.classList.contains('is-kt-rest')) {
        this.apply({ colors: this.state.colors, n: Math.max(this.state.n, parseInt(ret.n, 10) || 0) }, true);
      }
      if (li.classList.contains('is-kt-rest')) return;
      window.requestAnimationFrame(function () {
        li.scrollIntoView({ block: 'center' });
      });
    }

    /* ---------- úvod: „Číst dál", přilepená lišta ---------- */

    _setupClamp() {
      this._desc = this.querySelector('[data-kt-clamp]');
      this._descMore = this.querySelector('.nebe-kt-intro__more');
      if (!this._desc || !this._descMore) return;
      this._checkClamp();
      if (window.ResizeObserver) {
        var self = this;
        this._ro = new ResizeObserver(function () { self._checkClamp(); });
        this._ro.observe(this._desc);
      }
    }
    _checkClamp() {
      if (!this._desc || !this._descMore || this._desc.classList.contains('is-kt-open')) return;
      var over = this._desc.scrollHeight > this._desc.clientHeight + 1;
      if (this._descMore.hidden === over) this._descMore.hidden = !over;
    }
    _openClamp() {
      if (!this._desc) return;
      this._desc.classList.add('is-kt-open');
      this._descMore.hidden = true;
    }

    // lišta se lepí pod hlavičku motivu, pokud je hlavička přilepená
    _measureSticky() {
      var h = document.querySelector('.shopify-section-header, #shopify-section-header, sticky-header');
      var top = 0;
      if (h) {
        var pos = getComputedStyle(h).position;
        if (pos === 'sticky' || pos === 'fixed') top = h.offsetHeight;
      }
      this.style.setProperty('--kt-sticky-top', top + 'px');
    }

  }

  window.customElements.define('nebe-kolekce', NebeKolekce);
})();
